import React from 'react';

function NoCriteria() {
	return (
		<div className="practiceManagementForm" style={{ border: '1px solid #dadada' }}>
			<div className="noDataFound">
				<p>No Data found matching the criteria</p>
			</div>
		</div>
	);
}
export default NoCriteria;
